import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import axios from 'axios';

// Store
import { Provider } from 'react-redux';
import storeConfig from "./@core/redux/storeConfig/store";

// @Utility
import apiDomain from "./@utility/app/apiDomain";

const store = storeConfig();
const apiUrl = process.env?.REACT_APP_API_URL;
const reqUrl = apiUrl || apiDomain(window.location.host);
axios.defaults.baseURL = reqUrl;

// ตั้งค่า timeout รวม (หน่วยเป็นมิลลิวินาที)
// 5 นาที = 5 * 60 * 1000 = 300000
axios.defaults.timeout = 300000;

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();